// extracted by mini-css-extract-plugin
module.exports = {"footer_landingpage":"style_footer_landingpage__1bSrJ","footer_detail":"style_footer_detail__m-zDF","button":"style_button__dtMO5","copyright":"style_copyright__1YvUm"};